















import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-link-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionLinkItemStoreEdit from '@/store/modules/cvSectionLinkItemEdit';
import { CvSectionLinkItem } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    sectionItem: {
      type: Object as PropType<CvSectionLinkItem>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, url }: FormDataInterface) {
      const { cv_section_link_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionLinkItemStoreEdit.UpdateCvSectionLinkItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_link_id,
            id,
          },
          body: {
            title,
            url,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_section_link_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionLinkItemStoreEdit.DeleteCvSectionLinkItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_link_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
